import { isDate, isNumber, isString } from "lodash";
import { DateTime } from "luxon";

export type DateLike = number | string | Date | DateTime;
export const isDateLike = (dateInput: unknown): dateInput is DateLike =>
  isString(dateInput) || isNumber(dateInput) || isDate(dateInput) || DateTime.isDateTime(dateInput);

// see list of supported format tokens: https://moment.github.io/luxon/#/formatting?id=table-of-tokens
export enum DateFormat {
  // time formats
  TIME = "hh:mm a", // ex. "07:00 AM", "11:15 PM"
  MILITARY_TIME = "HH:mm", // ex. "07:00", "23:15"

  // date formats
  YEAR_MONTH = "yyyy-MM", // ex. "2023-12", "2024-01"
  YEAR_MONTH_DAY = "yyyy-MM-dd", // ex. "2023-12-01", "2024-01-15"
  FULL_MONTH_YEAR = "LLLL yyyy", // ex. "February 2023", "May 2025"
  YEAR_MONTH_DATE_SLASH_DELIMITED = "LL/dd/yyyy", // ex. "2023/01/12", "2023/11/31"

  // datetime formats
  MONTH_DAY_TIME = "LLL dd h:mm a", // ex. "Nov 10 11:24 PM", "Feb 7 7:42 AM";
}
